import React, { useState, useEffect, useCallback } from "react";
import { capitalize } from "lodash";

import "./Transaction.css";
// import NoSavestTransacttion from "./NoSavestTransaction";
import SavestPlanDetails from "./SavestPlanDetails";
import savestfeeicon from "../../assets/savestfee-icon.svg";
// import savesthouseicon from "../../assets/savest-houseicon.svg";
import closemodalicon from "../../../../Assets/closemodalicon.svg";
import FlexPackageIndex from "./SavestModal/FlexiblePackageModal/FlexPackageIndex";
import SavestTransaction from "./SavestPay/SavestTransaction";
import { Util } from "../../../../../helpers/util";
import { $api } from "../../../../../helpers/$api";
// import { SavingPlanDetailModal } from "../../../../modals/saving-plan-details-modal";

// const SavingDetails = ({ show, data, onCloseClick }) => {
//   const [modal, setModal] = useState("saving-plan-detail");

//   return (
//     <>
//       <SavingPlanDetailModal
//         show={show && modal === "saving-plan-detail"}
//         onCloseClick={onCloseClick}
//         onBackClick={onCloseClick}
//         plan={data}
//       />
//     </>
//   );
// };

const Transaction = ({ balances, transactions }) => {
  transactions = Array.isArray(transactions) ? transactions : [];
  const [change, setChange] = useState(0);
  const [userPlans, setUserPlans] = useState([]);
  // const [show, setShow] = useState(false);
  const [modalData, setModalData] = useState(null);
  const { currency } = Util.getCurrency();

  // const handlePlanClick = (data) => {
  //   setModalData(data);
  //   setShow(true);
  // };

  // const handleCloseClick = () => {
  //   setShow(false);
  // };

  const getAsyncData = useCallback(async () => {
    try {
      const userPlans = await $api.user.getUserSavestPlans();
      setUserPlans(Array.isArray(userPlans) ? userPlans : []);
    } catch (error) {}
  }, [setUserPlans]);

  useEffect(() => {
    getAsyncData();
  }, [getAsyncData]);

  return (
    <div className="TransactionSection">
      <div className="transactions">
        <div className="no-savest-transaction">
          {/* <NoSavestTransacttion /> */}
          <SavestTransaction
            transactions={transactions.map((trans) => {
              const isDebit = trans.type.toLowerCase().includes("withdraw");

              trans.prev_balance = isDebit
                ? trans.amount + 1
                : trans.amount - 1;
              trans.avail_balance = trans.amount;
              trans.isDebit = isDebit;
              return trans;
            })}
          />
        </div>
        <div className="savestplan-details">
          {userPlans.map((plan, i) => {
            const isFlexible = plan.saving_type === "flexible";
            return (
              <a href="#tuitionindexmodal">
                <div
                  className={`the-tuition-fee-section ${i && "mt-5"}`}
                  style={{
                    cursor: "pointer",
                    background: isFlexible ? "#E5F4FF;" : "#FAECFF",
                  }}
                  key={plan.id}
                  onClick={() => setModalData(plan)}
                >
                  <SavestPlanDetails
                    img={savestfeeicon}
                    key={plan.id}
                    title={
                      plan.name_of_plan ||
                      `${capitalize(plan.saving_type)} saving plan`
                    }
                    amount={`${currency} ${Util.formatMoneyNumber(
                      plan.wallet
                    )}`}
                    type={"Balance"}
                    interest={"Interest Rate"}
                    percentage={`${plan.profit_rate}%`}
                    active={"Active"}
                    duration={"status"}
                  />
                </div>
              </a>
            );
          })}
          {/* <a href="#tuitionindexmodal">hello</a>

          <div className="the-house-rent-section mt-5">
            <SavestPlanDetails
              img={savesthouseicon}
              title={"Fixed Plan"}
              amount={`${currency} 0.00`}
              type={"Fixed Savest Plan"}
              interest={"Interest Rate"}
              percentage={"0.00"}
              active={"Active"}
              duration={"Per Annum"}
            />
          </div> */}
        </div>
      </div>
      {/* <SavingDetails
        show={show}
        onCloseClick={handleCloseClick}
        data={modalData}
      /> */}
      <>
        {modalData && (
          <div id="tuitionindexmodal" className="tuitionindexmodal">
            <div className="investmodal-head">
              {change === 0 ? (
                <a
                  href="#dummy"
                  className="closemodalicon-btn"
                  onClick={() => {
                    setChange(0);
                  }}
                >
                  <img src={closemodalicon} alt="" className="closemodal" />
                </a>
              ) : null}

              <FlexPackageIndex
                {...{ change, setChange, balances, getAsyncData }}
                data={modalData}
              />
            </div>
          </div>
        )}
      </>
    </div>
  );
};

export default Transaction;
